import UserCenterMenu from '../components/UserCenterMenu'
import UserProfile from '../components/UserProfile'
import EditPassword from '../components/EditPassword'
import FollowCompany from '../components/FollowCompany'

let user_center = {
  // router,
  data () {
    return {
      oaid: null
    }
  },
  components: {
    UserCenterMenu, UserProfile, EditPassword, FollowCompany
  }
}

export default user_center



// WEBPACK FOOTER //
// ./src/user_center/js/user_center.js